import { createContext, useCallback, useContext, useState } from 'react';
import _ from 'lodash';
import WMICRiskPublicIdUtil from './WMICRiskPublicIdUtil';
import { RISK_PATHS } from './StringConstants';

const CanJumpToWizardStepDispatchContext = createContext(null);

export function CanJumpToWizardStepProvider({
    canJumpToWizardStepState,
    setCanJumpToWizardStepState,
    clearVisitedStepsAfterCurrent,
    children,
}) {
    const [startingRiskPublicIds, setStartingRiskPublicIds] = useState([]);

    const initDispatch = useCallback(
        vm => {
            if (startingRiskPublicIds.length === 0) {
                setStartingRiskPublicIds(
                    WMICRiskPublicIdUtil.getAllRiskPublicIds(
                        _.get(vm.value, RISK_PATHS.DWELLINGS_PATH),
                        _.get(vm.value, RISK_PATHS.WATERCRAFT_PATH),
                        _.get(vm.value, RISK_PATHS.VEHICLES_PATH),
                        _.get(vm.value, RISK_PATHS.DRIVERS_PATH)
                    )
                );
            }
        },
        [startingRiskPublicIds]
    );

    const canJumpToWizardStep = useCallback(
        action => {
            const setNewState = allowUserToJumpForward => {
                const newState = {
                    allowUserToJumpForward,
                    targetStep: canJumpToWizardStepState.targetStep,
                };
                canJumpToWizardStepState.allowUserToJumpForward = allowUserToJumpForward;
                setCanJumpToWizardStepState(newState);
                clearVisitedStepsAfterCurrent(newState);
            };

            switch (action.type) {
                case 'effectiveDateChanged':
                case 'riskAdded': {
                    setNewState(false);
                    break;
                }
                case 'reset': {
                    const doNewAndOldRiskPublicIdsMatch = WMICRiskPublicIdUtil.doNewAndOldRiskPublicIdsMatch(
                        startingRiskPublicIds,
                        _.get(action.vm.value, RISK_PATHS.DWELLINGS_PATH),
                        _.get(action.vm.value, RISK_PATHS.WATERCRAFT_PATH),
                        _.get(action.vm.value, RISK_PATHS.VEHICLES_PATH),
                        _.get(action.vm.value, RISK_PATHS.DRIVERS_PATH)
                    );

                    if (doNewAndOldRiskPublicIdsMatch) {
                        setNewState(true);
                    }
                    break;
                }
                case 'quoted': {
                    setNewState(true);
                    break;
                }
            }
        },
        [canJumpToWizardStepState, setCanJumpToWizardStepState, clearVisitedStepsAfterCurrent]
    );

    const canJumpToWizardStepProps = {
        initDispatch,
        wizardStepDispatch: canJumpToWizardStep,
    };

    return (
        <CanJumpToWizardStepDispatchContext.Provider value={canJumpToWizardStepProps}>
            {children}
        </CanJumpToWizardStepDispatchContext.Provider>
    );
}

export function useCanJumpToWizardStepDispatch() {
    return useContext(CanJumpToWizardStepDispatchContext);
}
